import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Injectable } from '@angular/core';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { IModule, IModuleImpact, ModuleConfigSchema } from '../models/setup.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getModuleDisplayName } from '../models/module-dependencies.const';

@Injectable({
  providedIn: 'root'
})
export class ModuleService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Module`;

  constructor(
    private readonly http: HttpClient,
    protected readonly toast: ToastService
  ) {
    super(toast);
  }

  getAll(includeInactive = false): Observable<ResponseDefault<IModule[]>> {
    const params = new HttpParams().set('includeInactive', String(includeInactive));
    return this.http
      .get<ResponseDefault<IModule[]>>(`${this.apiUrl}`, { params })
      .pipe(map((response) => ({ ...response, data: response.data?.map(withDisplayName) })));
  }

  setActive(moduleId: string, active: boolean): Observable<ResponseDefault<IModule>> {
    return this.http.patch<ResponseDefault<IModule>>(`${this.apiUrl}/${moduleId}/active`, { active });
  }

  getImpact(moduleId: string): Observable<ResponseDefault<IModuleImpact>> {
    return this.http.get<ResponseDefault<IModuleImpact>>(`${this.apiUrl}/${moduleId}/impact`);
  }

  getModuleConfigSchema(moduleId: string): Observable<ResponseDefault<ModuleConfigSchema>> {
    return this.http
      .get<ResponseDefault<ModuleConfigSchema>>(`${this.apiUrl}/${moduleId}`)
      .pipe(map((response) => ({ ...response, data: response.data && withDisplayName(response.data) })));
  }
}

function withDisplayName<T extends { route: string; name: string }>(module: T): T {
  return { ...module, name: getModuleDisplayName(module) };
}
